export function getExtraInfoByBrand(infosArray, brand) {
  const currentInfo = (infosArray || []).find((info) => info.brand === brand)

  return currentInfo?.text || ''
}
